<app-lfsa-gh-gauge *ngIf="bandera" [data]="variable"></app-lfsa-gh-gauge>
<app-lfsa-gh-gauge *ngIf="!bandera" [data]="variable"></app-lfsa-gh-gauge>

<input (keyup)="change()" [(ngModel)]="variable" type="number">
